import './AboutDetails.css'

function AboutDetails() {
    return (
        <div className='about-details-container'>
            <div className='about-details grid grid-cols-14 w-full gap-4 items-center h-full'>
                {/* Empty column */}
                <div className='col-span-1 h-full flex items-center'></div>

                {/* Main content in first 5 columns */}
                <div className='col-span-5 h-full flex items-center'>
                    <div className='font-screen-monitor leading-normal text-[clamp(12px,1.5vw,18px)]'>
                        Christian Horrer is a designer and art director based in Berlin. For the past four years, he has been working as a multidisciplinary freelance graphic designer, primarily in the fields of music, fashion and culture.<br />
                        Additionally he has been freelancing for the GOAT Group since 2022 regularly.
                        <br /><br />
                        Christian Horrer takes a conceptual and detail- oriented approach that bridges across media and programs while leaving room for experimentation.
                    </div>
                </div>

                {/* Empty column */}
                <div className='col-span-1 h-full flex items-center'></div>

                {/* Selected Clients column */}
                <div className='col-span-2 h-full flex items-center'>
                    <div className='leading-normal text-[clamp(8px,1vw,12px)] whitespace-nowrap font-semi-bold'>
                        Selected Clients
                        <br></br><br></br>
                        Alias.org<br></br>
                        Cleptomanicx<br></br>
                        Disruption DJ<br></br>
                        Flause Kollektiv Goe<br></br>
                        Fight Club<br></br>
                        Goat Group<br></br>
                        Nulleins Records<br></br>
                        Sony Music Germany<br></br>
                        Techno Germany<br></br>
                        Veit Dj
                    </div>
                </div>

                {/* Features & Publications column */}
                <div className='col-span-2 h-full flex items-center'>
                    <div className='leading-normal text-[clamp(8px,1vw,12px)] whitespace-nowrap font-semi-bold'>
                        Features & Publications
                        <br></br><br></br>
                        Blank Poster Volume 1<br></br>
                        C24 Archive One<br></br>
                        New Aesthetics 2019<br></br>
                        Page Mag<br></br>
                        Saiten Kulturmagazin<br></br>
                        tomorrow.type.today<br></br>
                        <br></br><br></br><br></br><br></br>


                        Awards<br></br><br></br>

                        Konstanzer Designpreis
                    </div>
                </div>

                {/* Education column */}
                <div className='col-span-2 h-full flex items-center'>
                    <div className='leading-normal text-[clamp(8px,1vw,12px)] whitespace-nowrap font-semi-bold'>
                        Education
                        <br></br><br></br>
                        2016-2021<br></br>
                        Communication Design Studies<br></br>
                        HTWG Constance, Germany<br></br>
                        2012-2015<br></br>
                        Apprenticeship Graphic Design Assistent<br></br>
                        <br></br><br></br><br></br>


                        Work Experience in Design<br></br><br></br>

                        2021-now<br></br>
                        Full Time Freelance<br></br>
                        2019-2020<br></br>
                        Volunteer for KD—Lounge Lecture Series<br></br>
                        2019<br></br>
                        Internship at Deutsche & Japaner<br></br><br></br><br></br><br></br>



                        Exhibitons<br></br>
                        <br></br>
                        2019-2021<br></br>
                        Part of the Werkschau every Semester<br></br>
                        HTWG Constance, Germany<br></br><br></br>

                        Typojanchi 2019<br></br>
                        6th International Typography Biennale<br></br><br></br>

                        Captcha 2019
                    </div>
                </div>

                {/* Empty column */}
                <div className='col-span-1 h-full flex items-center'></div>
            </div>
        </div>
    )
}

export default AboutDetails;